import React, { useEffect } from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import { useParams, useLocation } from 'react-router' 
import ViewPartnerDetails from '../../containers/partners/ViewPartnerDetails';
import UsersProvider from '../../store/users/usersProvider';
import AddPartner from '../../containers/partners/AddPartner';
import ClinicsProvider from '../../store/clinics/clinicsProvider';

function PartnerDetails() {
  const { id } = useParams(); 
  const location = useLocation();

  const { appState: { user }} = useApp();
  const [pageTitle, setPageTitle] = React.useState('');

  const addPartner = location.pathname.includes('/add');

  useEffect(() => {
    if (id) setPageTitle('Partner details');
    if (addPartner) setPageTitle('Add partner');
  }, [])

  if (!user) return '';
  if (!user._id) return '';

  return (
    <UsersProvider>
      <ClinicsProvider>
        <PageWrapper navbar title={pageTitle}>
          {id && <ViewPartnerDetails partnerId={id}/>}
          {addPartner && <AddPartner />}
        </PageWrapper>
      </ClinicsProvider>
    </UsersProvider>
  )
}

export default PartnerDetails;